import { recoilPersist } from "recoil-persist"

const { persistAtom } = recoilPersist({
  key: "recoilPersist", // Key for storage
  storage: localStorage, // Storage to use
})

export default persistAtom
